import styled, { keyframes } from "styled-components";
import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SmallLoading from "../Componentes/Utils/SmallLoading";
import FormComp from "../Componentes/FormComp";
import axios from "axios";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import SortableTable from "../Componentes/Utils/SortableTable";
import { formatarData } from "../Funcoes/FormatarData";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import { toast, ToastContainer } from "react-toastify";
import GenericHeader from "../Componentes/GenericHeader";
import Filters from "../Componentes/Utils/Filters";
import FilterContainer from "../Componentes/Utils/FilterContainer";
import useApi from "../hooks/useApi";

import { FiDownload, FiUpload } from "react-icons/fi";
import { AiOutlineClose, AiOutlineLoading3Quarters } from "react-icons/ai";
import { CiSearch } from "react-icons/ci";
import FileUploader from "../Componentes/Utils/FileUploader";

const PAGE_SIZE = 100;
const SCROLL_THRESHOLD = 40;


const ContainerNewDds = styled.div`
    width: 550px;
    max-width: 95%;
    max-height: 80%;
    background-color: transparent;
    border-radius: 12px;
    margin: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`
const ContainerHeader = styled.div`
    width: 100%;
    height: 45px;
    background-color: #263B4B;
    flex-shrink: 0;
    display: flex;
`
const ContainerBody = styled.div`
    width: 100%;
    flex: 1;
    background-color: white;
    overflow: auto;
    padding: 10px 20px;
    box-sizing: border-box;
`
const FormularioDds = styled.form`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`
const InputMatContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    color: black;
    p{
        margin: 15px auto 10px auto;
        font-weight: bold;
        color: black;
    }
`
const ContainerMat = styled.div`
    width: 100%;
    height: 40px;
    border: 1px solid #00000049;
    border-radius: 12px;
    display: flex;
    box-sizing: border-box;
    padding: 0 10px;
`
const InputMat = styled.input`
    flex: 1;
    height: 100%;
    border: none;
    outline: none;
    box-sizing: border-box;
`
const IconMat = styled.div`
    height: 100%;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
        cursor: pointer;
    }
`
const ModalColabsContainer = styled.div`
    width: 550px;
    max-width: 95%;
    max-height: 80%;
    margin: auto;
    border-radius: 12px;
    overflow: hidden;
`
const ModalColabsHeader = styled.div`
    width: 100%;
    height: 45px;
    background-color: #263B4B;
    flex-shrink: 0;
    display: flex;
`
const ModalColabsBody = styled.div`
    width: 100%;
    max-height: calc( 100% - 45px );
    background-color: white;
    overflow: auto;
    padding: 10px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    h3{
        color: black;
        font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
        margin: 10px auto;
    }
`
const TableWrapper = styled.div`
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #CFD1D0;
    box-sizing: border-box;
    margin-bottom: 15px;
`
const TabelaSubordinados = styled.table`
    width: 100%;
    color: black;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    border-collapse: collapse;
    border: none;
    box-sizing: border-box;
`
const HeaderTable = styled.tr`
    height: 35px;
    background-color: #F6F8FA;
    border-bottom: 1px solid #CFD1D0;
`
const ColunaHead = styled.th`
    padding: 0 0 0 8px;
    box-sizing: border-box;
    text-align: left;
`
const LineTable = styled.tr`
    height: 30px;
    background-color: #FFFFFD;
    border-bottom: 1px solid #CFD1D0;
    &:last-child{
        border: none;
    }
`
const ColunaBody = styled.td`
    padding-left: 10px;
    text-align: left;
    box-sizing: border-box;
`
const CloseModal = styled(AiOutlineClose)`
    width: 30px;
    height: 30px;
    color: red;
    margin: auto 15px auto auto;
    cursor: pointer;
    transition: .3s;
    &:hover{
        scale: 1.1;
    }
`

const PageContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-sizing: border-box;
    overflow: hidden;
`;

const TableFlexFill = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;

    & > div {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
`;

const AcoesCelula = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
`;

const BotaoAcao = styled.button`
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;

    color: ${(p) => (p.$danger ? "#b91c1c" : "#1d4ed8")};
    background-color: ${(p) =>
        p.$danger ? "rgba(185, 28, 28, 0.12)" : "rgba(29, 78, 216, 0.10)"};
    border: 1px solid transparent;

    &:hover {
        background-color: ${(p) =>
            p.$danger ? "rgba(185, 28, 28, 0.22)" : "rgba(29, 78, 216, 0.20)"};
        border-color: ${(p) =>
            p.$danger ? "rgba(185, 28, 28, 0.5)" : "rgba(29, 78, 216, 0.45)"};
    }

    &:focus-visible {
        outline: 2px solid ${(p) => (p.$danger ? "#b91c1c" : "#1d4ed8")};
        outline-offset: 2px;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

const IconLoad = styled(AiOutlineLoading3Quarters)`
    animation: ${spin} 0.8s linear infinite;
`;

const ListaDDS = () => {

    const api = useApi();
    const tableRef = useRef(null);

    const [modalColabs, setModalColabs] = useState(false)
    const [subordinados, setSubordinados] = useState({})

    const [modalForm, setModalForm] = useState(false)

    const temasSeguranca = [
        "ALIMENTAÇÃO SAUDÁVEL NO AMBIENTE DE TRABALHO",
        "ANÁLISE PRELIMINAR DE RISCO — APR NO DIA A DIA",
        "ATENDIMENTO EM CASO DE CHOQUE ELÉTRICO",
        "ATENDIMENTO EM CASO DE QUEIMADURAS",
        "ATOS INSEGUROS — RECONHECER E ELIMINAR",
        "CUIDADOS COM A AUDIÇÃO — PROTEÇÃO AUDITIVA",
        "CUIDADOS COM A COLUNA E LEVANTAMENTO DE PESO",
        "CUIDADOS COM A VISÃO — PROTEÇÃO OCULAR",
        "CUIDAR DE SI E DOS COLEGAS — SEGURANÇA É RESPONSABILIDADE COMPARTILHADA",
        "CULTURA DE SEGURANÇA — SEGURANÇA É DEVER DE TODOS",
        "COMBATE AO ALCOOLISMO E USO DE DROGAS NO TRABALHO",
        "COMUNICAÇÃO EFETIVA EM SEGURANÇA",
        "CONDUTA EM CASO DE ACIDENTE DE TRABALHO",
        "CONTROLE DE DERRAMAMENTOS E EMERGÊNCIAS AMBIENTAIS",
        "DESCARTE CORRETO DE RESÍDUOS",
        "DOENÇAS OCUPACIONAIS E COMO PREVENIR",
        "ERGONOMIA — PREVENÇÃO DE DORES E LESÕES",
        "ESPAÇOS CONFINADOS — RISCOS E PROCEDIMENTOS",
        "HIGIENE PESSOAL NO AMBIENTE DE TRABALHO",
        "IMPACTOS AMBIENTAIS DAS ATIVIDADES DA EMPRESA",
        "IMPORTÂNCIA DA BRIGADA DE INCÊNDIO",
        "IMPORTÂNCIA DA HIDRATAÇÃO",
        "INSPEÇÃO E CONSERVAÇÃO DE EPIs",
        "PRESERVAÇÃO DA ÁGUA E ENERGIA",
        "PREVENÇÃO À FADIGA E ESTRESSE",
        "PREVENÇÃO CONTRA INCÊNDIOS — USO DE EXTINTORES",
        "PREVENÇÃO DE ACIDENTES COM LÍQUIDOS INFLAMÁVEIS",
        "PROCEDIMENTOS EM CASOS DE QUEDAS",
        "PROTEÇÃO DE MÁQUINAS E EQUIPAMENTOS",
        "QUEDAS NO MESMO NÍVEL — COMO EVITAR",
        "RADIAÇÕES IONIZANTES E NÃO IONIZANTES",
        "REUTILIZAÇÃO E RECICLAGEM NO CANTEIRO DE OBRAS",
        "RISCOS DE CHOQUE ELÉTRICO",
        "RISCOS DE PRODUTOS QUÍMICOS (FDS FICHA DE INFORMAÇÕES DE SEGURANÇA)",
        "RISCOS DE QUEDAS EM ALTURA",
        "RISCOS EM TRABALHOS A QUENTE (SOLDA, ESMERILHAMENTO, CORTE)",
        "RUÍDO OCUPACIONAL — DANOS E PREVENÇÃO",
        "SAÚDE MENTAL E EQUILÍBRIO EMOCIONAL",
        "SEGURANÇA EM TRABALHOS COM SOLDA E CORTE",
        "SEGURANÇA NO MANUSEIO DE FERRAMENTAS MANUAIS",
        "SEGURANÇA NO TRANSPORTE DE MATERIAIS",
        "SEGURANÇA NO USO DE LÍQUIDOS PENETRANTES (LP)",
        "SIMULADOS DE EMERGÊNCIA — IMPORTÂNCIA E PARTICIPAÇÃO",
        "SUSTENTABILIDADE NA CONSTRUÇÃO CIVIL",
        "TRABALHOS COM ELETRICIDADE — RISCOS E CUIDADOS",
        "USO CORRETO DOS EPIs",
        "VIBRAÇÃO — EFEITOS NA SAÚDE"
    ];

    const [formValues, setFormValues] = useState({
        encarregado: '',
        nome: '',
        lider: '',
        equipe: '',
        periodo: '',
        centro_custo: '',
        contrato: '',
        inicio_semana: '',
        tema_1: '',
        tema_2: '',
        tema_3: '',
        tema_4: '',
        tema_5: '',
        tema_6: '',
        tema_7: '',
        observacoes: ''
    })

    const handleChange = (field, value) => {
        if (field === 'inicio_semana' && value !== '') {
            const dia_semana = new Date(value).getDay();

            if (value === "" || dia_semana !== 0) {
                alert('A data selecionada não é uma segunda-feira!');
                return;
            }
        }

        setFormValues(prev => ({ ...prev, [field]: value }));
    };

    const [savingDados, setSavingDados] = useState(false);

    const handleSubmit = async (e) => {

        e.preventDefault();

        setSavingDados(true);

        try {

            await toast.promise(
                axios.post(
                    'https://sistemaintegrado.palmont.com.br/Painel/API/DDSList/SaveDDS/',
                    formValues,
                    {
                        withCredentials: true
                    }
                ),
                {
                    pending: "SALVANDO INFORMAÇÕES",
                    success: "DADOS SALVOS COM SUCESSO",
                    error: "ERRO AO SALVAR INFORMAÇÕES"
                }
            )

            await fetchData();
            fecharDDSForm();

        } catch (error) {

            console.log(error)

        } finally {

            setSavingDados(false)

        }

    }

    const getColabsInfo = async (matricula) => {

        try {

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/GetColabInfo/', {

                matricula: matricula

            })

            console.log(data)

            setFormValues(prev => ({
                ...prev,
                centro_custo: data[0].CENTRO_CUSTO ? data[0].CENTRO_CUSTO : '-',
                contrato: data[0].CONTRATO ? data[0].CONTRATO : '-',
                nome: data[0].NOME ? data[0].NOME : '-',
                equipe: data[0].DISCIPLINA ? data[0].DISCIPLINA : '-',
                lider: data[0].LIDER ? data[0].LIDER : null
            }
            ));

        } catch (e) {

            console.log(e)

        }

    }

    useEffect(() => {
        const fetchColab = async () => {
            if (formValues.encarregado.length === 6) {

                await getColabsInfo(formValues.encarregado);

            } else {

                setFormValues(prev => ({
                    ...prev,
                    centro_custo: '',
                    contrato: '',
                    nome: '',
                    equipe: '',
                    lider: ''
                }
                ));

            }
        };

        fetchColab();
    }, [formValues.encarregado]);

    const [loadingSubordinados, setLoadingSubordinados] = useState(false);

    const openEncInfo = async () => {

        if (formValues.encarregado.length === 6) {

            setModalColabs(true)
            setLoadingSubordinados(true);

            try {

                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/DDSList/GetEncInfo/', {
                    matricula: formValues.encarregado
                },
                    {
                        withCredentials: true
                    })

                setSubordinados(data)
                console.log(data)

            } catch (e) {

                console.log(e)

            } finally {

                setLoadingSubordinados(false)

            }

        } else {

            alert("Matricula incompleta!")

        }

    }

    const closeEncInfo = () => {

        setModalColabs(false)
        setLoadingSubordinados(false);

    }

    const [listaDDS, setListaDDS] = useState([])
    const [listaDDSFilter, setListaDDSFilter] = useState([])
    const [loading, setLoading] = useState(true)
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)
    const [downloadingIds, setDownloadingIds] = useState({})
    const [modalAnexos, setModalAnexos] = useState(false)
    const [idAnexo, setIdAnexo] = useState('')
    const [matriculaFilter, setMatriculaFilter] = useState('')
    const [nomeFilter, setNomeFilter] = useState('')
    const [centroCustoFilter, setCentroCustoFilter] = useState([])
    const [contratoFilter, setContratoFilter] = useState([])
    const [periodoFilter, setPeriodoFilter] = useState('')
    const [anexoFilter, setAnexoFilter] = useState('')
    const [dataInicioFilter, setDataInicioFilter] = useState('')
    const [dataFimFilter, setDataFimFilter] = useState('')

    const fetchData = async () => {

        setLoading(true)

        try {

            const { data } = await api.get('/Painel/API/DDSList/GetDDS/')

            const lista = Array.isArray(data) ? data : []
            setListaDDS(lista)
            setListaDDSFilter(lista)

        } catch (e) {

            console.log(e)
            setListaDDS([])
            setListaDDSFilter([])

        } finally {

            setLoading(false)

        }

    }

    useEffect(() => {

        fetchData();

    }, [])

    const [sideOverlay, setSideOverlay] = useState(false)

    const openSidebar = () => {

        setSideOverlay(true)

    }

    const closeSidebar = () => {

        setSideOverlay(false)

    }

    const gerarNovoDDS = () => {

        setSideOverlay(false)
        setModalForm(true)

        setFormValues({
            encarregado: '',
            nome: '',
            lider: '',
            equipe: '',
            periodo: '',
            centro_custo: '',
            contrato: '',
            area: '',
            inicio_semana: '',
            tema_1: '',
            tema_2: '',
            tema_3: '',
            tema_4: '',
            tema_5: '',
            tema_6: '',
            tema_7: '',
            observacoes: ''
        });

    }

    const fecharDDSForm = () => {

        setModalForm(false);
        setFormValues({
            encarregado: '',
            nome: '',
            lider: '',
            equipe: '',
            periodo: '',
            centro_custo: '',
            contrato: '',
            area: '',
            inicio_semana: '',
            tema_1: '',
            tema_2: '',
            tema_3: '',
            tema_4: '',
            tema_5: '',
            tema_6: '',
            tema_7: '',
            observacoes: ''
        });

    }

    const centro_custos = useMemo(() => [...new Set(listaDDS.map((obj) => obj.centro_custo))].sort(), [listaDDS])
    const contratos = useMemo(() => [...new Set(listaDDS.map((obj) => obj.contrato))].sort(), [listaDDS])

    const handleFilter = useCallback(() => {
        setListaDDSFilter(
            listaDDS.filter(item => {

                const matriculaOk = !matriculaFilter || item.encarregado.includes(matriculaFilter);
                const nomeOk = !nomeFilter || item.nome.toLowerCase().includes(nomeFilter.toLowerCase());

                const centroCustoOk = !centroCustoFilter.length || centroCustoFilter.some(f => item.centro_custo === f.value);
                const contratoOk = !contratoFilter.length || contratoFilter.some(f => item.contrato === f.value);

                const periodoOk = !periodoFilter.length || periodoFilter.some(obj => (item.periodo || '').includes(obj.value))

                const anexoOk =
                    !anexoFilter.length ||
                    (anexoFilter.some(obj => obj.value === 'OK') && item.anexo !== null) ||
                    (anexoFilter.some(obj => obj.value === 'PENDENTES') && item.anexo === null);

                const dataInicioOk = !dataInicioFilter || new Date(item.semana) >= new Date(dataInicioFilter);
                const dataFimOk = !dataFimFilter || new Date(item.semana) <= new Date(dataFimFilter);

                return matriculaOk && nomeOk && centroCustoOk && contratoOk && periodoOk && anexoOk && dataInicioOk && dataFimOk;
            })
        );
    }, [listaDDS, matriculaFilter, nomeFilter, centroCustoFilter, contratoFilter, periodoFilter, anexoFilter, dataInicioFilter, dataFimFilter]);

    useEffect(() => {

        handleFilter();

    }, [handleFilter])

    useEffect(() => {
        setVisibleCount(PAGE_SIZE);
        if (tableRef.current) {
            tableRef.current.scrollTop = 0;
        }
    }, [listaDDSFilter]);

    const loadMoreRows = useCallback(() => {
        setVisibleCount((prev) => {
            const total = listaDDSFilter.length;
            if (prev >= total) return prev;
            return Math.min(prev + PAGE_SIZE, total);
        });
    }, [listaDDSFilter.length]);

    const downloadExcel = useCallback(async (id, resp_name) => {
        setDownloadingIds((prev) => {
            if (prev[id]) return prev;
            return { ...prev, [id]: true };
        });

        try {
            const { data } = await toast.promise(
                api.post(
                    "/Painel/API/DDSList/GenerateNewFile/",
                    { id },
                    { responseType: "blob" }
                ),
                {
                    pending: "BAIXANDO ARQUIVO",
                    success: "ARQUIVO BAIXADO COM SUCESSO",
                    error: "FALHA AO BAIXAR ARQUIVO",
                }
            );

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `DDS - ${resp_name}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.log(e);
        } finally {
            setDownloadingIds((prev) => {
                const next = { ...prev };
                delete next[id];
                return next;
            });
        }
    }, [api]);

    const openAnexo = useCallback((id) => {
        setModalAnexos(true);
        setIdAnexo(id);
    }, []);

    const closeAnexo = () => {
        setModalAnexos(false);
        setIdAnexo('');
    };

    const columns = useMemo(
        () => [
            {
                id: "id",
                header: "ID",
                accessor: "id",
                sortable: true,
                width: "70px",
                align: "center",
            },
            {
                id: "encarregado",
                header: "MATRÍCULA",
                accessor: "encarregado",
                sortable: true,
                width: "110px",
            },
            {
                id: "nome",
                header: "ENCARREGADO",
                accessor: "nome",
                sortable: true,
            },
            {
                id: "centro_custo",
                header: "CENTRO CUSTO",
                accessor: "centro_custo",
                sortable: true,
            },
            {
                id: "contrato",
                header: "CONTRATO",
                accessor: "contrato",
                sortable: true,
            },
            {
                id: "periodo",
                header: "PERÍODO",
                accessor: "periodo",
                sortable: true,
                width: "100px",
                render: (value) => (value === "MANHA" ? "MANHÃ" : value ?? "-"),
            },
            {
                id: "semana",
                header: "INÍCIO",
                accessor: "semana",
                sortable: true,
                width: "120px",
                render: (value) => (value ? formatarData(value) : "-"),
                sortValue: (row) => row.semana ?? "",
            },
            {
                id: "acoes",
                header: "AÇÕES",
                sortable: false,
                width: "90px",
                align: "center",
                render: (_, row) => {
                    const isDownloading = Boolean(downloadingIds[row.identifier]);

                    return (
                        <AcoesCelula>
                            {isDownloading ? (
                                <BotaoAcao type="button" disabled title="Baixando planilha...">
                                    <IconLoad size={14} />
                                </BotaoAcao>
                            ) : (
                                <BotaoAcao
                                    type="button"
                                    title="Baixar planilha Excel"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        downloadExcel(row.identifier, row.nome);
                                    }}
                                >
                                    <FiDownload size={14} />
                                </BotaoAcao>
                            )}
                            {row.anexo ? (
                                <BotaoAcao
                                    as="a"
                                    href={row.anexo}
                                    download
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="Baixar anexo"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <FiDownload size={14} />
                                </BotaoAcao>
                            ) : (
                                <BotaoAcao
                                    type="button"
                                    title="Anexar lista DDS"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openAnexo(row.identifier);
                                    }}
                                >
                                    <FiUpload size={14} />
                                </BotaoAcao>
                            )}
                        </AcoesCelula>
                    );
                },
            },
        ],
        [downloadExcel, downloadingIds, openAnexo]
    );

    return (
        <>
            <NavBar title="CONTROLE DE DDS" setSideBar={() => openSidebar()} />
            <GenericBody>
                <PageContent>
                <GenericHeader responsive>
                    <Filters columns={4}>
                        <FilterContainer
                            type="text"
                            placeholder="MATRICULA..."
                            valor={matriculaFilter}
                            changeFunc={(valor) => setMatriculaFilter(valor)}
                        />
                        <FilterContainer
                            type="text"
                            placeholder="NOME..."
                            valor={nomeFilter}
                            changeFunc={(valor) => setNomeFilter(valor)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CENTRO CUSTO..."
                            options={centro_custos}
                            optType="obj"
                            valor={centroCustoFilter}
                            changeFunc={setCentroCustoFilter}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CONTRATO..."
                            options={contratos}
                            optType="obj"
                            valor={contratoFilter}
                            changeFunc={setContratoFilter}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="PERIODO..."
                            options={[{ value: "MANHA", label: "MANHÃ" }, { value: "TARDE", label: "TARDE" }]}
                            valor={periodoFilter}
                            changeFunc={setPeriodoFilter}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="ANEXO..."
                            options={[
                                "OK",
                                "PENDENTES"
                            ]}
                            optType="obj"
                            valor={anexoFilter}
                            changeFunc={setAnexoFilter}
                        />
                        <FilterContainer
                            type="date"
                            valor={dataInicioFilter}
                            changeFunc={(valor) => setDataInicioFilter(valor)}
                        />
                        <FilterContainer
                            type="date"
                            valor={dataFimFilter}
                            changeFunc={(valor) => setDataFimFilter(valor)}
                        />
                    </Filters>

                </GenericHeader>

                <TableFlexFill>
                    <SortableTable
                        ref={tableRef}
                        columns={columns}
                        data={listaDDSFilter}
                        limit={visibleCount}
                        onScrollReachEnd={loadMoreRows}
                        scrollReachThreshold={SCROLL_THRESHOLD}
                        isLoading={loading}
                        loadingText="Carregando DDS..."
                        emptyText="Nenhum DDS encontrado."
                        initialSort={{ key: "id", direction: "desc" }}
                        getRowId={(row) => row.id}
                    />
                </TableFlexFill>
                </PageContent>
            </GenericBody>
            <Overlay state={modalForm}>
                <ContainerNewDds>
                    <ContainerHeader>
                        <CloseModal onClick={fecharDDSForm} />
                    </ContainerHeader>
                    <ContainerBody>
                        {
                            savingDados ? (
                                <SmallLoading />
                            ) : (
                                <FormularioDds onSubmit={handleSubmit} >
                                    <InputMatContainer>
                                        <p>ENCARREGADO ( MATRICULA )</p>
                                        <ContainerMat>
                                            <InputMat
                                                type="text"
                                                value={formValues.encarregado}
                                                onChange={(e) => handleChange('encarregado', e.target.value)}
                                                maxLength={6}
                                                required
                                            ></InputMat>
                                            <IconMat>
                                                <CiSearch
                                                    size={30}
                                                    onClick={() => openEncInfo()}
                                                />
                                            </IconMat>
                                        </ContainerMat>
                                    </InputMatContainer>
                                    <FormComp
                                        type="text"
                                        title="NOME | DISCIPLINA"
                                        valor={formValues.nome + " | " + formValues.equipe}
                                        disabled
                                        readOnly
                                    />
                                    <FormComp
                                        type="text"
                                        title="CENTRO DE CUSTO"
                                        valor={formValues.centro_custo}
                                        disabled
                                        readOnly
                                    />
                                    <FormComp
                                        type="text"
                                        title="CONTRATO"
                                        valor={formValues.contrato}
                                        disabled
                                        readOnly
                                    />
                                    <FormComp
                                        type="select"
                                        title="PERIODO"
                                        options={
                                            ["MANHA", "TARDE"]
                                        }
                                        valor={formValues.periodo}
                                        changeFunc={(e) => handleChange('periodo', e.target.value)}
                                        required
                                    />
                                    <FormComp
                                        type="date"
                                        title="SEMANA"
                                        valor={formValues.inicio_semana}
                                        changeFunc={(e) => handleChange('inicio_semana', e.target.value)}
                                        required
                                    />
                                    {
                                        formValues.periodo === "MANHA" && (
                                            <>
                                                <FormComp
                                                    type="select"
                                                    title="TEMA SEGUNDA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_1}
                                                    changeFunc={(e) => handleChange('tema_1', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA TERCA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_2}
                                                    changeFunc={(e) => handleChange('tema_2', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA QUARTA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_3}
                                                    changeFunc={(e) => handleChange('tema_3', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA QUINTA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_4}
                                                    changeFunc={(e) => handleChange('tema_4', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA SEXTA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_5}
                                                    changeFunc={(e) => handleChange('tema_5', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA SABADO"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_6}
                                                    changeFunc={(e) => handleChange('tema_6', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA DOMINGO"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_7}
                                                    changeFunc={(e) => handleChange('tema_7', e.target.value)}
                                                />
                                            </>
                                        )
                                    }
                                    <FormComp
                                        type="textarea"
                                        title="OBSERVACOES"
                                        valor={formValues.observacoes}
                                        changeFunc={(e) => handleChange('observacoes', e.target.value)}
                                    />
                                    <FormComp
                                        type="submit"
                                        valor="SALVAR"
                                    />
                                </FormularioDds>
                            )
                        }
                        <Overlay state={modalColabs} >
                            <ModalColabsContainer>
                                <ModalColabsHeader>
                                    <CloseModal onClick={closeEncInfo} />
                                </ModalColabsHeader>
                                <ModalColabsBody>
                                    {
                                        loadingSubordinados ?
                                            <SmallLoading /> :
                                            <>
                                                <h3>{subordinados?.ENCARREGADO}</h3>
                                                <TableWrapper>
                                                    <TabelaSubordinados>
                                                        <thead>
                                                            <HeaderTable>
                                                                <ColunaHead>COLABORADOR</ColunaHead>
                                                                <ColunaHead>MATRICULA</ColunaHead>
                                                            </HeaderTable>
                                                        </thead>
                                                        <tbody>
                                                            <LineTable>
                                                                <ColunaBody>{subordinados?.LIDER?.[0]?.NOME}</ColunaBody>
                                                                <ColunaBody>{subordinados?.LIDER?.[0]?.MATRICULA}</ColunaBody>
                                                            </LineTable>
                                                            {
                                                                subordinados?.SUBORDINADOS?.length === 0 ? (
                                                                    <LineTable>
                                                                        <ColunaBody colSpan={2}>COLABORADOR NÃO POSSUI NENHUM SUBORDINADO</ColunaBody>
                                                                    </LineTable>
                                                                ) : (
                                                                    subordinados?.SUBORDINADOS?.map((obj, index) => (
                                                                        <LineTable key={index}>
                                                                            <ColunaBody>{obj.NOME}</ColunaBody>
                                                                            <ColunaBody>{obj.MATRICULA}</ColunaBody>
                                                                        </LineTable>
                                                                    ))
                                                                )
                                                            }
                                                        </tbody>
                                                    </TabelaSubordinados>
                                                </TableWrapper>
                                            </>
                                    }
                                </ModalColabsBody>
                            </ModalColabsContainer>
                        </Overlay>
                    </ContainerBody>
                </ContainerNewDds>
            </Overlay>
            <Overlay state={sideOverlay} changeContent={() => closeSidebar()} >
                <SideMenu>
                    <SideMenuBtn button="GERAR DDS" clickFunc={gerarNovoDDS} />
                </SideMenu>
            </Overlay>
            <Overlay state={modalAnexos} >
                <FileUploader
                    title="Anexar lista DDS"
                    uploadUrl="https://sistemaintegrado.palmont.com.br/Painel/API/DDSList/UploadFile/"
                    extraFormData={
                        { id: idAnexo }
                    }
                    close={closeAnexo}
                    onSuccess={fetchData}
                />
            </Overlay>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                style={{
                    zIndex: '99999'
                }}
            />
        </>
    )

}

export default ListaDDS;